import '../App.css';
import Main from './main';

function Acompanhando() {
  return (
    <div className="App">
        <Main />
    </div>
  );
}

export default Acompanhando;
